module.exports = __webpack_public_path__ + "static/img/4.5e71e826.png";